import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createStaticVNode as _createStaticVNode } from "vue"
import _imports_0 from '@/assets/thum_img/kp708b/sub4_1/54131fa75a7288dcb2c757f455317ec8_water__c1_w280_h397.jpg'


const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = { class: "width_wrap" }
const _hoisted_3 = { class: "body_content" }
const _hoisted_4 = { class: "menu-A-read-wrap" }
const _hoisted_5 = { class: "btn" }

import BoardNavbar from "@/views/product/activity/Navbar.vue";
import Banner from "@/components/Banner.vue";

import { watch } from "vue";
import { USER_ROUTES } from "@/assets/route_constants.ts";
import { useRouter } from "vue-router";
import { useAuth } from "@/composables/useAuth";
import { useAlertDialog } from "@/composables/useAlert";

export default /*@__PURE__*/_defineComponent({
  __name: 'High',
  setup(__props) {

const useAlert = useAlertDialog();
const { isLoggedIn } = useAuth();
const router = useRouter();
watch(
  isLoggedIn,
  async (newValue) => {
    if (newValue === false) {
      await useAlert("회원전용 페이지 입니다. 로그인 후 이용해주세요.");
      // TODO : 단순히 뒤로 갈지 향후 확인 후 변경 가능.
      // router.back();
      router.push({ name: USER_ROUTES.Home.Name });
    }
  },
  { immediate: true }
);

return (_ctx: any,_cache: any) => {
  const _component_n_space = _resolveComponent("n-space")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_unref(isLoggedIn))
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createVNode(Banner, {
          title: "Activity",
          subtitle: "Activity",
          description: "학생들과 함께 그들의 미래를 찾는 일을 하고자 합니다. <br>\n        자신의 미래에 관심이 있는 학생 누구에게나 도움을 주고자 합니다."
        }),
        _createVNode(BoardNavbar),
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _cache[5] || (_cache[5] = _createElementVNode("h1", { class: "sub_subject" }, "재능진로전공직업 탐색 프로젝트", -1)),
            _createElementVNode("div", _hoisted_4, [
              _cache[3] || (_cache[3] = _createElementVNode("div", null, [
                _createElementVNode("ul", { class: "line line4" }, [
                  _createElementVNode("li", null, "PUTT2.0기반 전공탐색 프로젝트"),
                  _createElementVNode("li", null, [
                    _createElementVNode("dl", { class: "line2" }, [
                      _createElementVNode("dt", null, "제목"),
                      _createElementVNode("dd", null, "“(지속 가능한 지구 살리기) 미래 도시를 건립하다!”")
                    ])
                  ])
                ])
              ], -1)),
              _createElementVNode("div", null, [
                _createElementVNode("ul", null, [
                  _createElementVNode("li", null, [
                    _createElementVNode("figure", null, [
                      _createVNode(_component_n_space, { justify: "center" }, {
                        default: _withCtx(() => _cache[0] || (_cache[0] = [
                          _createElementVNode("img", {
                            src: _imports_0,
                            alt: ""
                          }, null, -1)
                        ])),
                        _: 1
                      })
                    ])
                  ]),
                  _cache[1] || (_cache[1] = _createStaticVNode("<li data-v-3501de43><dl data-v-3501de43><dt data-v-3501de43>목적</dt><dd data-v-3501de43> 본 활동은 학생의 경험을 기반으로, 미래 최적의 재능을 발휘할 전공 탐색을 목적으로 한다. </dd></dl><dl data-v-3501de43><dt data-v-3501de43>목표</dt><dd data-v-3501de43> 목표 1. (강의를 들으면서) 세상 이해 및 자기 이해를 통해 자기개념을 정립한다.<br data-v-3501de43> 목표 2. 팀 구성원 간 재능 및 관심을 소개, 공유, 논의 과정을 통해 전공 분야에 관한 인식을 다각적으로 탐색, 심화한다.<br data-v-3501de43> 목표 3. ‘미래 신도시 건립 프로젝트’ 참여를 위한 가상의 과제 제안서 작성을 통해 관심 전공을 면밀하게 탐색한다. <br data-v-3501de43> 목표 4. ‘목표 3’을 통해 팀 과업 과정에서 만나게 된 경험을 팀별로 발표하고, 개별 에세이를 작성, 제출한다. </dd></dl><dl data-v-3501de43><dt data-v-3501de43>대상</dt><dd data-v-3501de43>고1 – 고3</dd></dl><dl class=\"line2\" data-v-3501de43><dt data-v-3501de43>시간</dt><dd data-v-3501de43>6시간 (사전 1시간ㅣ집합 5시간)</dd></dl></li>", 1))
                ])
              ]),
              _cache[4] || (_cache[4] = _createStaticVNode("<div data-v-3501de43><ul class=\"line line4\" data-v-3501de43><li data-v-3501de43>JIGSAW 수업</li><li data-v-3501de43><dl class=\"line2\" data-v-3501de43><dt data-v-3501de43>재료</dt><dd data-v-3501de43> •자료 1. 팀별 명단: PUTT2.0 결과를 기반으로, 팀(4인1팀)을 구성(팀 내, 유사한 재능 유형으로), 명단을 조직<br data-v-3501de43> •자료 2. 활동지: ‘미래 도시 건립’ 사업의 수주를 위한 (가상)과업 제안서 (Worksheet. 1 – 4) <br data-v-3501de43> •자료 3. 또래평가지: 다른 팀의 ‘과업제안서’ 평가에 사용할 ‘과업제안서 평가지’ (Worksheet. 5)<br data-v-3501de43> •자료 4. 에세이 양식: “미래 글로벌 리더의 창조적 경험” 작성 (Worksheet. 6) </dd></dl></li></ul></div><div data-v-3501de43><ul class=\"line\" data-v-3501de43><li data-v-3501de43> 결과물<br data-v-3501de43> + PUTT2.0 결과리포트<br data-v-3501de43> + 팀 과업 제안서<br data-v-3501de43> + 발표 자료 </li><li data-v-3501de43><dl class=\"line2\" data-v-3501de43><dt data-v-3501de43>구성</dt><dd data-v-3501de43> • 모듈 1. [사전 진단] PUTT2.0 - 1주일 전 - On-Line 실시 – 팀 배치<br data-v-3501de43> • 모듈 2. [강의] (1) PUTT2.0 결과 – 전공별 사례 소개, (2) 과제 소개 및 안전 교육<br data-v-3501de43> • 모듈 3. [과제 수행] (1) 팀별 구성원 소개, (2) 전공 논의 (학과명/ 분야명/ 전문성 및 역량/ 주요 수업/ 산업체 등) <br data-v-3501de43> (3) 과제 논의 및 결정, (4) 개별 직무 및 조직 구성, 세부 내용 구성<br data-v-3501de43> • 모듈 4. [제안서 및 에세이 작성] (1) 프로젝트 논의 및 제안서 작성, 발표 (2) 자기소개를 위한 에세이 작성 </dd></dl></li></ul></div><div data-v-3501de43><ul class=\"line\" data-v-3501de43><li data-v-3501de43>진행: 관리자</li><li data-v-3501de43><dl class=\"line2\" data-v-3501de43><dt data-v-3501de43>활용</dt><dd data-v-3501de43> •전공 탐색을 통해 개인의 재능을 재구조화 하여 관심 분야에서의 경쟁력을 높임<br data-v-3501de43> •’고교학점제’의 단중장기적 학업계획 수립을 위한 자신의 재능 구조 측정, 성장 예측, 전공선택 전략 수립에 유용 </dd></dl></li></ul></div>", 3)),
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_router_link, {
                  to: `${_unref(USER_ROUTES).Product.Activity.Talent.Path}`
                }, {
                  default: _withCtx(() => _cache[2] || (_cache[2] = [
                    _createTextVNode("목록")
                  ])),
                  _: 1
                }, 8, ["to"])
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})